// contexts/pedidos/ConfigWhatsContext.js
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { fetchData, postData, putData } from '../../services/Api';
import { conectarWhats as conectarWhatsService, createInstance as createInstanceService, getConnectionState } from '../../services/pedidos/WhatsService';
import { useAlert } from '../geral/AlertContext';
import { useMessage } from '../geral/MessageContext';
import ConfigWhatsCad from '../../pages/pedidos/ConfigWhatsCad';


const ConfigWhatsContext = createContext();

export const useConfigWhats = () => useContext(ConfigWhatsContext);

export const ConfigWhatsProvider = ({ children }) => {
    const [configWhats, setConfigWhats] = useState();
    const { showAlert } = useAlert();
    const { showMessage } = useMessage();

    useEffect(() => {
        const fetchDataFromAPI = async () => {
            try {
                const result = await fetchData('/ConfigWhats/GetFirst');
                setConfigWhats(result);

                if (result && !result.desativarWhats) {
                    try {
                        const statusConexao = await getConnectionState();

                        if (!statusConexao?.conectado) {
                            showMessage('O WhatsApp está desconectado! \n\n Para conectá-lo, ir em "Configurações->Configuração do WhatsApp", clique em "Conectar".', 'warning');
                        }
                    } catch (error) {
                        console.error('Erro ao consultar o status da conexão do WhatsApp:', error);
                        showMessage('O WhatsApp está desconectado! \n\n Para conectá-lo, ir em "Configurações->Configuração do WhatsApp", clique em "Conectar".', 'warning');
                    }
                }
            } catch (error) {
                console.error("Erro ao buscar configurações do WhatsApp:", error);
                showAlert('Erro ao buscar configuração do WhatsApp!', 'danger');
            }
        };
        fetchDataFromAPI();
    }, []);

    const insertConfigWhats = async (configWhats) => {
        try {
            const result = await postData('/ConfigWhats', configWhats);
            setConfigWhats(result);
            showAlert('Configuração do WhatsApp cadastrada com sucesso!');
        } catch (error) {
            console.error("Erro ao cadastrar configuração do WhatsApp:", error);
            showAlert('Erro ao cadastrar configuração do WhatsApp!', 'danger');
        }
    };

    const updateConfigWhats = async (configWhats) => {
        try {
            const result = await putData('/ConfigWhats', configWhats);
            setConfigWhats(result);
            showAlert('Configuração do WhatsApp alterada com sucesso!');
        } catch (error) {
            console.error("Erro ao atualizar configuração do WhatsApp:", error);
            showAlert('Erro ao alterar configuração do WhatsApp!', 'danger');
        }
    };

    const conectarWhats = async (configWhats) => {
        try {
            const result = await conectarWhatsService(configWhats.id);
            setConfigWhats({ ...configWhats, qrCode: result.qrCode });
            showAlert('QR Code gerado! Escaneie para conectar o WhatsApp.');                       
        } catch (error) {
            console.error("Erro ao conectar o WhatsApp:", error);
            showAlert('Erro ao conectar o WhatsApp!', 'danger');
            throw error;
        }
    };

    const createInstance = async (configWhats) => {
        try {
            await createInstanceService(configWhats.id);
            showAlert('Instância criada com sucesso!');                       
        } catch (error) {
            console.error("Erro ao atualizar configuração do WhatsApp:", error);
            showAlert('Erro ao alterar configuração do WhatsApp!', 'danger');
        }
    };

    const consultarStatusConexao = useCallback(async () => {
        return getConnectionState();
    }, []);

    // Modal Cadastro Config WhatsApp
    const [showModalWhats, setShowModalWhats] = useState(false);
    const showWhatsCad = () => {
        setShowModalWhats(true);
    };

    const handleCloseModalWhats = () => {
        setShowModalWhats(false);
    };

    return (
        <ConfigWhatsContext.Provider value={{ configWhats, setConfigWhats, insertConfigWhats, updateConfigWhats, showWhatsCad, conectarWhats, createInstance, consultarStatusConexao }}>
            {children}
            <ConfigWhatsCad
                show={showModalWhats}
                onHide={handleCloseModalWhats}
            />
        </ConfigWhatsContext.Provider>
    );
};
